import { render, staticRenderFns } from "./DSCheckboxOnIcon.vue?vue&type=template&id=bb189b18&"
import script from "./DSCheckboxOnIcon.vue?vue&type=script&lang=js&"
export * from "./DSCheckboxOnIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports